<template>
  <v-container grid-list-xl class="pricelistEdit">
		<v-form v-model="isEditValid">
          <center><img style="padding-top: 7%;" src="../../shared/assets/images/3dloader.gif" v-if="pricelistEdit == ''" /></center>
          <center><img style="padding-top: 7%;" src="../../shared/assets/images/3dloader.gif" v-if="importingData == true" /></center>
            <v-layout row wrap v-if="pricelistEdit != '' && isLibraryUpdate == true">
                <v-flex lg12>
                    <v-btn v-show="isLibraryUpdate != false" @click="fncHideModal" color="success">Close</v-btn>
                    <v-btn v-show="isLibraryUpdate != false" @click="fncRunLibraryUpdate(false)" color="success">Decline Library Update</v-btn>
                    <v-btn v-show="isLibraryUpdate != false" @click="fncRunLibraryUpdate(true)" color="success">Accept Library Update</v-btn>
                    <v-text-field style="width: 25% !important" append-icon="search" label="Search" solo single-line v-model="searchLib"></v-text-field><br />
                </v-flex>
                <v-flex lg12>
                    <v-data-table :headers="libHeaders" :search="searchLib" :items="libraryDetails" class="elevation-1 linkTableMedium" hide-actions :rows-per-page-items="[20,40,60,80,100]">
                        <template slot="items" slot-scope="props">
                            <td width="25%">{{ props.item.name }}</td>
                            <td width="25%">{{ props.item.type }}</td>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
			      <v-layout row v-if="pricelistEdit != '' && isLibraryUpdate == false && importingData == true == false">
                <v-flex lg12 v-if="showUpload">
                  <input type="file" id="plistFile" class="fileUpload" @change="fncReadCsv">
                  <div class="fileHolder">
                    <p>Drag & Drop / Click to Add File</p>
                    <small>Once you upload the file, the import will occur</small>
                  </div>
                </v-flex>
                <v-flex lg2>
                  <v-switch @change="fncSetDefault()" label="Active" v-model="pricelistEdit.pl_active" solo single-line></v-switch>
                </v-flex>
                <v-flex lg2>
                  <v-switch label="Default Pricelist" v-model="pricelistEdit.pl_is_default" solo single-line></v-switch>
                </v-flex>
                <v-flex lg2>
                <v-switch label="Cost Pricelist" v-model="pricelistEdit.pl_is_cost" solo single-line></v-switch>
              </v-flex>
            </v-layout>
      <v-layout row v-if="pricelistEdit != '' && isLibraryUpdate == false && importingData == true == false">
				<v-flex lg2>
					<label class="blackLabel">* Pricelist Name:</label>
					<v-text-field label="Name" v-model="pricelistEdit.pl_name" :rules="nameRules" required solo single-line></v-text-field>
				</v-flex>
				<v-flex lg4>
					<label class="blackLabel">Pricelist Description:</label>
					<v-text-field label="Description" v-model="pricelistEdit.pl_description" solo single-line></v-text-field>
				</v-flex>
				<!--<v-flex lg4>
					<v-switch label="Active" v-model="pricelistEdit.pl_active" solo single-line></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="Default Pricelist" v-model="pricelistEdit.pl_is_default" solo single-line></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="Cost Pricelist" v-model="pricelistEdit.pl_is_cost" solo single-line></v-switch>
				</v-flex>-->
				<v-flex lg1>
					<label class="blackLabel">* Currency Symbol:</label>
					<v-text-field label="Currency Symbol" v-model="pricelistEdit.pl_currency_sym" required :rules="symbolRules" solo single-line></v-text-field>
				</v-flex>
				<v-flex lg1>
					<label class="blackLabel">* Tax Label:</label>
					<v-text-field label="Tax Label" v-model="pricelistEdit.pl_tax_label" required :rules="labelRules" solo single-line></v-text-field>
				</v-flex>
				<v-flex lg1>
					<label class="blackLabel">* Tax Rate(%):</label>
					<v-text-field label="Tax Rate" v-model="pricelistEdit.pl_tax_percentage" solo required :rules="taxRules" single-line></v-text-field>
				</v-flex>
				<v-flex lg1>
					<label class="blackLabel">Currency Code:</label>
					<v-text-field label="Currency Code" v-model="pricelistEdit.pl_currency_code" solo single-line></v-text-field>
				</v-flex>
      </v-layout>
      <v-layout row v-if="pricelistEdit != '' && isLibraryUpdate == false && importingData == true == false">
				<v-flex lg2 class="filterPrice">
					<label class="blackLabel">Pricing Table:</label>
					<v-select :items="priceTableList" @change="fncFilterTable" label="Type" v-model="pricelistTable" autocomplete solo item-value="text"></v-select>
				</v-flex>
                <v-flex lg2>
                  <label class="blackLabel">Action:</label>
                  <v-select :items="pricelistActions" label="-" v-model="pricelistAction" single-line solo></v-select>
                </v-flex>
                <v-flex lg2>
                  <label class="blackLabel">Percentage: (%)</label>
                  <v-text-field v-model="priceFilterPercentage" single-line solo></v-text-field>
                </v-flex>
                <v-flex lg2>
                  <label class="blackLabel">Roundup:</label>
                  <v-select :items="pricelistRoundupItems" label="None" v-model="pricelistRoundItem" single-line solo></v-select>
                </v-flex>
                <v-flex lg2>
                  <label class="blackLabel">Items:</label>
                  <v-select :items="pricelistFilterItems" label="All Items" v-model="pricelistFilterItem" single-line solo></v-select>
                </v-flex>
                <v-flex lg1>
                  <label class="blackLabel">&nbsp;</label>
                  <v-btn color="success" @click.stop="fncApplyFilters()">Apply</v-btn>
                </v-flex>
				<!--<v-flex lg3>
					<label class="blackLabel">Action:</label>
					<v-select :items="pricelistActions" label="-" v-model="pricelistAction" single-line solo></v-select>
				</v-flex>
				<v-flex lg3>
					<label class="blackLabel">Percentage: (%)</label>
					<v-text-field v-model="priceFilterPercentage" single-line solo></v-text-field>
				</v-flex>
				<v-flex lg4>
					<label class="blackLabel">Items:</label>
					<v-select :items="pricelistFilterItems" label="All Items" v-model="pricelistFilterItem" single-line solo></v-select>
				</v-flex>
				<v-flex lg1>
					<label class="blackLabel">&nbsp;</label>
					<v-btn color="success" class="text-xs-right" @click.stop="fncApplyFilters()">Apply</v-btn>
				</v-flex>-->
      </v-layout>
      <v-layout row v-if="pricelistEdit != '' && isLibraryUpdate == false && importingData == true == false">
				<v-flex lg12>
                    <v-data-table :headers="headers" :search="search" :items="priceTableAllSelected" class="elevation-1" hide-actions :rows-per-page-items="[20,40,60,80,100]">
                      <template slot="items" slot-scope="props">
                        <td width="5%" v-if="currentPriceTable == props.item.pli_pricing_table"><v-checkbox v-model="props.item.pli_filter"></v-checkbox></td>
                        <td width="25%" v-if="currentPriceTable == props.item.pli_pricing_table">{{ props.item.pli_code }}</td>
                        <td width="25%" v-if="currentPriceTable == props.item.pli_pricing_table">{{ props.item.pli_description }}</td>
                        <td width="25%" v-if="currentPriceTable == props.item.pli_pricing_table">{{ fncFormatPrice(props.item.pli_price) }}</td>
                        <td width="20%" v-if="currentPriceTable == props.item.pli_pricing_table"><v-text-field v-model="props.item.pli_new_price" solo></v-text-field></td>
                      </template>
                    </v-data-table>
                </v-flex>
				<div class="pl-4 pr-1 pb-4 buttonHolder">
					<!--<div style="float: right">
						<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
                        <v-btn color="success" class="text-xs-right" @click.stop="fncDownloadTemplate">Download Template</v-btn>
                        <v-btn color="success" class="text-xs-right" @click.stop="fncShowUpload">Import</v-btn>
                        <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
						<v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isEditValid" @click.stop="fncEditPlist()">Update</v-btn>
                        <small>* The button will activate once all required fields have been completed</small>
					</div>-->
                    <div style="float: right">
                        <v-btn v-show="isLibraryUpdate == false" class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
                        <v-btn v-show="isLibraryUpdate == false" color="success" @click.stop="fncDownloadTemplate">Download Template</v-btn>
                        <v-btn v-show="isLibraryUpdate == false" color="success" @click.stop="fncShowUpload">Import</v-btn>
                        <v-progress-circular v-show="isLibraryUpdate == false" indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
                        <v-btn v-show="isLibraryUpdate == false" color="success" v-if="!runAdd" @click.stop="fncEditPlist()">Update</v-btn>
                        <!--<v-btn v-show="isLibraryUpdate == false" color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isEditValid" @click.stop="fncEditPlist()">Update</v-btn>-->
                        <v-btn v-show="isLibraryUpdate == false && libraryLoading == false" color="success" @click.stop="fncLibraryUpdate">Library Update</v-btn>
                        <v-progress-circular v-show="libraryLoading == true" indeterminate :width="3" :size="20" color="grey" class="pt-3 loginLoader"></v-progress-circular>
                        <small>* The button will activate once all required fields have been completed</small>
                    </div>
				</div>
			</v-layout>
		</v-form>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
	  name: 'Settings',
	  data () {
        return {
                showUpload: false,
				search: '',
				isEditValid: false,
                searchLib: '',
				headers: [
					{ text: '', value: '', width: '5%' },
					{ text: 'Code', value: 'pl_code', width: '25%' },
                    { text: 'Description', value: 'pl_description', width: '25%' },
                    { text: 'Current Price', value: 'pl_price', width: '25%' },
                    { text: 'New Price', value: '', width: '20%' }
				],
				pricelistTable: '',
				currentPriceTable: '',
				pricelistAction: '',
				pricelistActions: [
					{ text: 'Increase By', action: 'increase' },
					{ text: 'Decrease By', action: 'decrease' }
				],
				priceFilterPercentage: '0.0',
				pricelistFilterItems: [
					{ text: 'Selected Items', action: 'selected' },
					{ text: 'Unselected Items', action: 'unselected' }
                ],
                pricelistRoundupItems: [
                  { text: 'Round Up Whole Number', action: 'roundup_number' },
                  { text: 'Round Down Whole Number', action: 'rounddown_number' },
                  { text: 'Round Up Decimal', action: 'roundup_decimal' },
                  { text: 'Round Down Decimal', action: 'rounddown_decimal' }
                ],
                libHeaders: [
                    { text: 'Name', value: 'name', width: '25%' },
                    { text: 'Type', value: 'type', width: '25%' },
                ],
                pricelistRoundItem: '',
				pricelistFilterItem: '',
				nameRules: [
					v => !!v || 'Pricelist name is required',
				],
				symbolRules: [
					v => !!v || 'Pricelist currency symbol is required',
				],
				labelRules: [
					v => !!v || 'Pricelist tax label is required',
				],
				taxRules: [
					v => !!v || 'Pricelist tax rate is required',
				],
				codeRules: [
					v => !!v || 'Pricelist currency code is required',
				]
			};
		},
      methods: {
        fncSetDefault() {
          if( this.pricelistEdit.pl_active == false ) {
            this.pricelistEdit.pl_is_default = false;
          }
        },
        fncShowUpload() {
          if ( this.showUpload == true ) {
            this.showUpload = false;
          } else {
            this.showUpload = true;
          }
        },
        fncReadCsv(e) {
          var files = e.target.files || e.dataTransfer.files;

          if (files[0].type === 'application/vnd.ms-excel' || files[0].type === 'text/csv') {
            var reader = new FileReader();
            var vm = this;
            reader.onload = function (e) {
              var plistResult = reader.result;
              var splitRows = plistResult.split("\n");
              vm.$store.commit('setImportingData', true);
              vm.$store.commit({
                type: 'fncSetPricelistImport',
                rows: splitRows,
                priceTable: vm.pricelistTable
              })
              vm.fileName = files[0].name;
              document.getElementById("plistFile").value = "";
            }
            reader.readAsText(files[0]);
            this.uploadValue = true;

          } else {
            var elFile = document.getElementById('plistFile');
            elFile.value = '';
            var snackDetails = { color: 'error', message: 'Please ensure that a CSV file has been uploaded', display: true };
            this.$store.commit('setSnack', snackDetails);
          }
        },
        fncDownloadTemplate() {
          var exportData = 'CODE, PRICE' + "\r\n";
          var n = 0;
          for (var k in this.priceTableAll) {
            if (this.priceTableAll[k].pli_pricing_table == this.pricelistTable ) {
              exportData += this.priceTableAll[k].pli_code + ',';
              exportData += this.priceTableAll[k].pli_price;
              exportData += "\r\n";
            }
          }
            var plistExport = document.createElement('a');
            plistExport.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(exportData));
            plistExport.setAttribute('download', 'pricelist_template.csv');
            plistExport.click();
          },
          fncHideModal() {
              this.$store.commit('fncIsLibraryUpdateFalse');
              if( this.priceTableList[0] ) {
                  this.currentPriceTable = this.priceTableList[0].text;
                  this.pricelistTable = this.priceTableList[0].text;
              }
              this.$store.commit('hideModal');
              this.$store.commit('setRunAdd', false);
              this.$store.commit('setLibraryLoading', false);
			},
			fncFormatPrice (intPrice) {
				return 'R' + parseFloat(intPrice).toFixed(2);
			},
			fncFilterTable(filterVal){
				this.pricelistTable = filterVal;
                this.currentPriceTable = filterVal;
                this.$store.commit('setPriceTableAllSelected', filterVal);
			},
			fncApplyFilters() {
				this.$store.commit({
					type: 'fncFilterPrices',
					priceList: this.currentPriceTable,
					action: this.pricelistAction,
					percentage: this.priceFilterPercentage,
                    items: this.pricelistFilterItem,
                    rounding: this.pricelistRoundItem.action
				})
			},
            fncEditPlist() {
                if( this.priceTableList[0] ) {
                    this.currentPriceTable = this.priceTableList[0].text;
                    this.pricelistTable = this.priceTableList[0].text;
                }
				this.$store.dispatch('fncEditPlist');
			},
            fncLibraryUpdate() {
                this.$store.commit( 'setLibraryLoading', true );
                this.$store.dispatch( 'fncDisplayLibraryUpdate', this.globalModalParams.editObj );
            },
              fncListLibraryDetails() {
                  var toReturn = '';

                  toReturn += '<table>';
                  for( var l in this.libraryDetails.diff ) {
                      toReturn += '<tr><td><h2>'+l.toUpperCase()+'</h2></td></tr>';
                      var n = 1;
                      for( var t in this.libraryDetails.diff[l] ) {
                          toReturn += '<tr><td>'+n+'. '+this.libraryDetails.diff[l][t]+'</td></tr>';
                          n++;
                      }
                  }
                  toReturn += '</table><br /><br />';

                  return toReturn;
              },
          fncRunLibraryUpdate( decision ) {

              this.$store.dispatch({
                  type: 'fncGetLibraryUpdate',
                  pricelist: this.globalModalParams.editObj,
                  decision: decision
              })

          }
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'runAdd',
                'priceTableAll',
                'priceTableAllSelected',
				'priceTableList',
				'pricelistEdit',
                'isLibraryUpdate',
                'libraryDetails',
                'libraryLoading',
        'importingData'
			])
		},
        created() {
            //this.$store.commit('setPriceTableAllSelected', this.priceTableList[0].text);
			//this.currentPriceTable = this.priceTableList[0].text;
			//this.pricelistTable = this.priceTableList[0].text;
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
